import { registerPlugin } from '@capacitor/core';

interface PrinterAndroid {
  print: (data: {pdfUrl: string}) => any;
}

const PrinterAndroid = registerPlugin<PrinterAndroid>('PrinterAndroid');

export default PrinterAndroid;
